export function init() {
  // Sharing Twitter Facebook
  // TWITTER
  const twitterShareButtons = document.querySelectorAll(".tweet");

  twitterShareButtons.forEach((twitterShareButton) => {
    if (twitterShareButton) {
      twitterShareButton.addEventListener("click", (event) => {
        event.preventDefault();
        let shareUrl = twitterShareButton.getAttribute(
          "data-twitter-sharing-url"
        );
        if (shareUrl) {
          shareUrl = shareUrl.replace(/&amp;/g, "&");
          window.open(
            decodeURIComponent(shareUrl),
            "twitterwindow",
            "height=450, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
          );
        }
      });
    }
  });

  // FACEBOOk
  var x = screen.width / 2 - 700 / 2;
  var y = screen.height / 2 - 450 / 2;
  const facebookShareButtons = document.querySelectorAll(".facebook");
  facebookShareButtons.forEach((facebookShareButton) => {
    if (facebookShareButton) {
      facebookShareButton.addEventListener("click", (event) => {
        event.preventDefault();
        let shareUrl = facebookShareButton.getAttribute(
          "data-facebook-sharing-url"
        );

        if (shareUrl) {
          shareUrl = shareUrl.replace(/&amp;/g, "&");
          window.open(
            decodeURIComponent(shareUrl),
            "facebookwindow",
            `height=450, width=700, top=${y}, left=${x}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`
          );
        }
      });
    }
  });
}
